import React from "react";

export default function GoogleMapsLogo({ className = "", size = 18 }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
        >
            <path d="M12 2.25c-3.5 0-6.34 2.75-6.34 6.15 0 4.58 4.63 9.95 5.91 11.35.23.25.63.25.86 0 1.28-1.4 5.91-6.77 5.91-11.35 0-3.4-2.84-6.15-6.34-6.15Z" fill="#34A853" />
            <path d="M12 2.25c3.5 0 6.34 2.75 6.34 6.15 0 1.24-.34 2.55-.86 3.83L12 8.4V2.25Z" fill="#4285F4" />
            <path d="M6.52 12.23c-.52-1.28-.86-2.59-.86-3.83 0-2.1 1.09-3.95 2.75-5.06L12 8.4l-5.48 3.83Z" fill="#FBBC04" />
            <path d="M12 8.4l5.48 3.83c-1.34 3.26-4.05 6.44-5.05 7.52-.23.25-.63.25-.86 0-1-1.08-3.71-4.26-5.05-7.52L12 8.4Z" fill="#EA4335" />
            <circle cx="12" cy="8.4" r="2.15" fill="white" />
            <circle cx="12" cy="8.4" r="1.12" fill="#4285F4" />
        </svg>
    );
}
